<template>
    <div class="payment-container">
        <!-- 步骤导航 -->
        <!-- <el-steps :active="activeStep" simple class="steps">
        <el-step title="Plan"></el-step>
        <el-step title="Payment"></el-step>
        <el-step title="Confirmation"></el-step>
      </el-steps> -->

        <div class="main-content">
            <!-- 左侧计划信息 -->
            <div class="left-panel">
                <div class="plan-info">
                    <h3>Premium Monthly</h3>
                    <div class="price-section">
                        <div class="price-line">
                            <span>Price:&nbsp;</span>
                            <span class="highlight-red">${{ planPrice }}</span>
                        </div>
                        <!-- <div class="detail-line">
                <span>Exchange rate</span>
                <span>{{ exchangeRate }}</span>
              </div>
              <div class="detail-line">
                <span>Discount</span>
                <span class="highlight-red">-R{{ discount }}</span>
              </div> -->
                    </div>
                    <!-- <div class="total-section">
              <span>Total:</span>
              <span class="total-amount highlight-red">R {{ totalAmount }}</span>
            </div> -->
                    <el-button
                        type="text"
                        class="change-plan"
                        @click="changePlan"
                        >Change plan</el-button
                    >
                </div>
                <!-- <div class="discount-section">
            <el-input 
              v-model="discountCode"
              placeholder="(optional) discount code"
              class="discount-input"
            >
              <el-button 
                slot="append" 
                class="apply-btn"
                @click="applyDiscount"
              >Apply</el-button>
            </el-input>
          </div> -->
            </div>

            <!-- 右侧支付信息 -->
            <div class="right-panel">
                <div class="payment-method">
                    <h4>Payment method</h4>
                    <div class="currency-select">
                        <span>Currency:</span>
                        <el-select v-model="currency" class="currency-dropdown">
                            <el-option label="ZAR" value="ZAR"></el-option>
                        </el-select>
                    </div>

                    <el-radio-group v-model="paymentMethod">
                        <el-radio label="credit">Credit/Debit card</el-radio>
                        <!-- <el-radio label="ewallet">e-wallet</el-radio> -->
                    </el-radio-group>

                    <!-- <div class="payment-note">
                    <i class="el-icon-info"></i>
                    <span>Note: Recommend using credit card to pay for it.</span>
                </div> -->

                    <!-- 支付图标 -->
                    <div class="payment-icons">
                        <img src="@/assets/img/paycard.png" alt="Credit Card" />
                    </div>
                </div>
            </div>
        </div>

        <!-- 下一步按钮 -->
        <div class="action-bar">
            <el-button type="primary" class="next-btn" @click="handleNext"
                >Next</el-button
            >
        </div>
    </div>
</template>
  
  <script>
export default {
    data() {
        return {
            activeStep: 1,
            planPrice: 15.0,
            exchangeRate: 18.34,
            discount: 0.0,
            discountCode: '',
            currency: 'ZAR',
            paymentMethod: 'credit',
            totalAmount: 275.14
        }
    },
    methods: {
        applyDiscount() {
            // 折扣应用逻辑
            // console.log('Applied discount code:', this.discountCode)
        },
        handleNext() {
            // 下一步操作
            this.activeStep = 2
        },
        changePlan() {
            this.$router.push('/')
        }
    }
}
</script>
  
  <style lang="scss" scoped>
.payment-container {
    max-width: 1200px;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    .steps {
        margin-bottom: 40px;
    }

    .main-content {
        display: flex;
        gap: 30px;

        .left-panel,
        .right-panel {
            flex: 1;
        }
    }

    .highlight-red {
        color: #f56c6c;
        font-weight: bold;
    }

    .plan-info {
        border: 1px solid #ebeef5;
        padding: 20px;
        border-radius: 4px;

        h3 {
            margin: 0 0 15px 0;
        }

        .price-section {
            margin-bottom: 15px;
        }

        .total-section {
            display: flex;
            justify-content: space-between;
            margin: 20px 0;
            font-size: 16px;
        }
    }
    /*
    .discount-section {
      margin-top: 20px;
  
      .discount-input {
        /deep/ .el-input-group__append {
          background-color: #f56c6c;
          color: white;
          border: none;
        }
      }
    }
    */
    .payment-method {
        padding: 20px;
        border: 1px solid #ebeef5;
        border-radius: 4px;

        .currency-select {
            margin: 15px 0;
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .payment-note {
            color: #909399;
            margin: 15px 0;
        }
    }

    .payment-icons {
        display: flex;
        gap: 15px;
        margin-top: 20px;

        img {
            height: 45px;
        }
    }

    .action-bar {
        margin-top: 30px;
        text-align: right;

        .next-btn {
            background: #f56c6c;
            border: none;
            padding: 12px 40px;
        }
    }
}

/* 移动端适配 */
@media (max-width: 768px) {
    .payment-container {
        margin: 10px;
        padding: 10px;

        .main-content {
            flex-direction: column;

            .left-panel,
            .right-panel {
                width: 100%;
            }
        }

        .plan-info {
            padding: 15px;
        }

        .payment-method {
            padding: 15px;
        }

        .payment-icons {
            flex-wrap: wrap;
            justify-content: center;
        }

        .next-btn {
            width: 100%;
        }
    }
}
</style>